var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-wrapper',{attrs:{"standalone":true}},[_c('saved-search-wizard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }